import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'

import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import CustomBadge from 'designer/component/element/Badge'

export const BadgeSystem = (props) => (
  <DragElementWrapper {...props}>
    <CustomBadge {...props} />
  </DragElementWrapper>
)

export const BadgeDisplay = (props) => (
  <ElementWrapper {...props}>
    <CustomBadge {...props} />
  </ElementWrapper>
)

export const badgeTester = rankWith(1000, scopeEndsWith('badge'))
